/* Message Klarna — auto-fit sur une ligne (même principe que Trustpilot).
   Réduit la police de .klarna-message UNIQUEMENT si la ligne déborde de sa colonne.
   Mesure la largeur RÉELLE de la colonne (scrollWidth > clientWidth), pas le viewport
   -> sur PC, iPad et mobile le texte rétrécit seulement quand c'est nécessaire, sans
   agrandir l'espace au-dessus (la police reste sur le <p>). Premier-party, ~0,4 Ko. */
(function () {
  function fit(el) {
    el.style.fontSize = '';
    var size = parseFloat(getComputedStyle(el).fontSize) || 13;
    var guard = 0;
    while (el.scrollWidth > el.clientWidth + 0.5 && size > 8 && guard < 40) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
      guard++;
    }
  }
  function run() {
    var list = document.querySelectorAll('.klarna-message');
    for (var i = 0; i < list.length; i++) fit(list[i]);
  }
  var raf;
  function onResize() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(run);
  }
  if (document.readyState === 'loading') {
    addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  addEventListener('resize', onResize, { passive: true });
})();
